import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';

@Injectable()
export class DocumentService {
  private resourceUrl = environment.apiUrl + 'document';
  private documentUrl = environment.documentUrl;

  constructor(private http: HttpClient) {
  }

  loadAttachment(file: File, fileType: number, idStructure: number): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('type', fileType + '');
    return this.http.post<any[]>(this.resourceUrl + '/' + idStructure + '/create', formData, {observe: 'response'});
  }

  downloadAttachment(idAttachment: number): Observable<Blob> {
    return this.http.get(this.documentUrl + idAttachment, {responseType: 'blob'});
  }

  downloadAttachmentByUrl(url: string): Observable<Blob> {
    return this.http.get(url, {responseType: 'blob'});
  }

  deleteAttachemnt(idStructure: number, idAttachment: number): Observable<any>  {
    return this.http.delete<any>(this.resourceUrl + '/' + idStructure + '/' + idAttachment + '');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/document.service.ts